import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import TableColumns from 'components/organisms/TableColumns/TableColumns/TableColumns';

const StyledEntitiesTableColumns = styled(TableColumns)`
  ${ComponentStyles}
`;

StyledEntitiesTableColumns.propTypes = {
  theme: PropTypes.object
};

export default StyledEntitiesTableColumns;
